//# sourceMappingURL=ai_config.mjs.map
/// <reference types="./ai_config.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $ai_config from "../../../data_types/data/ai_config.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $toast from "../../../redraw_toastify/toastify/toast.mjs";
import * as $function from "../../../tiamat/tiamat/function.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";

export function fetch_ai_config(org_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          dispatch(
            new $msg.AiConfig(new $msg.ApiStartedLoadingAiConfig(org_id)),
          );
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["organizations", org_id, "ai-config"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Get());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.expect(
            _pipe$2,
            $decode.at(
              toList(["ai_config"]),
              $decode.optional($ai_config.decoder()),
            ),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (c) => {
              let _pipe$4 = new $msg.ApiReturnedAiConfig(org_id, c);
              let _pipe$5 = new $msg.AiConfig(_pipe$4);
              dispatch(_pipe$5);
              return undefined;
            },
          );
          return $ask.run(_pipe$4);
        },
      );
    },
  );
}

export function fetch_ai_configs() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(new $ask.Admin(), toList(["ai-configs"]));
          let _pipe$1 = $ask.via(_pipe, new $http.Get());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.expect(_pipe$2, $decode.list($ai_config.decoder()));
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (ai_configs) => {
              let _pipe$4 = new $msg.ApiReturnedAiConfigs(ai_configs);
              let _pipe$5 = new $msg.AiConfig(_pipe$4);
              dispatch(_pipe$5);
              return undefined;
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (_) => {
              let _pipe$5 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Failed to load the AI configs",
              );
              return dispatch(_pipe$5);
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

export function set_ai_config(ai_config) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["organizations", ai_config.org_id, "ai-config"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.with$(_pipe$2, $ai_config.encode(ai_config));
          let _pipe$4 = $ask.expect(_pipe$3, $ai_config.decoder());
          let _pipe$5 = $ask.on_success(
            _pipe$4,
            (c) => {
              dispatch(new $msg.AiConfig(new $msg.ApiSavedAiConfig(c)));
              return undefined;
            },
          );
          let _pipe$6 = $ask.on_error(
            _pipe$5,
            (_) => {
              let _pipe$6 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Failed to save AI config for " + ai_config.org_id,
              );
              return dispatch(_pipe$6);
            },
          );
          let _pipe$7 = $ask.run(_pipe$6);
          return $promise.map(_pipe$7, $function.constant(undefined));
        },
      );
    },
  );
}
